import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@cots/common/services/navigation.service';
import { UserService } from '@cots/common/services/user.service';
import { UtilityService } from '@cots/common/services/utility.service';
import { SearchData } from '../search-list-new/search-list-new.component';
import { MyTicketsItem, MyTicketsService } from '@cots/common/services/myTickets.service';

@Component({
  selector: 'my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.less']
})
export class MyTicketsComponent implements OnInit {

  constructor(public service: MyTicketsService, private userService: UserService, private navService: NavigationService) {
    navService.clearBreadCrumbs();
    navService.setPageTitle("My Tickets");
  }

  ngOnInit(): void {
  }

  daysLeft(date: string, abs: boolean): number | null {
    if (date == null) return null;

    return UtilityService.getDaysRemaining(new Date(date), abs);
  }

  public daysLeftColorClass(date: string) {
    const days = this.daysLeft(date, false);
    if (days < 0) return 'bg-danger text-dark';
    if (days <= 2) return 'bg-danger text-white';
    else if (days <= 7) return 'bg-warning text-dark';
    else return 'bg-info text-white';
  }

  public onSelect(ticket: MyTicketsItem) {
    window.open(ticket.url, "_blank");
  }

  public search(data: SearchData) {
    return this.service.getMyTickets(data.page.pageIndex);
  }

  public get displayedColumns() {
    return ['department', 'ticketName', 'description', 'dueDate'];
  }

}
